export const VISTA_CURSO_RETURN_GESTION = "gestion";
export const VISTA_CURSO_RETURN_EDITOR = "editor";

/**
 * @param {string | null | undefined} returnTo
 * @returns {typeof VISTA_CURSO_RETURN_GESTION | typeof VISTA_CURSO_RETURN_EDITOR | null}
 */
function normalizeReturnTo(returnTo) {
  if (returnTo === VISTA_CURSO_RETURN_EDITOR || returnTo === VISTA_CURSO_RETURN_GESTION) {
    return returnTo;
  }
  return null;
}

/**
 * @param {string | null | undefined} courseId
 * @returns {string}
 */
function encodeCourseIdForPath(courseId) {
  const id = typeof courseId === "string" ? courseId.trim() : "";
  return id.length > 0 ? encodeURIComponent(id) : "";
}

/**
 * @param {string | null | undefined} returnTo
 * @param {string | null | undefined} courseId
 * @returns {string}
 */
export function resolveVistaCursoAdminExitPath(returnTo, courseId) {
  const encodedId = encodeCourseIdForPath(courseId);
  const safeReturnTo = normalizeReturnTo(returnTo);
  if (safeReturnTo === VISTA_CURSO_RETURN_EDITOR && encodedId.length > 0) {
    return `/admin/editar-curso/${encodedId}?tab=vista`;
  }
  if (safeReturnTo === VISTA_CURSO_RETURN_GESTION) {
    return "/GestionCursos";
  }
  if (encodedId.length > 0) {
    return `/admin/editar-curso/${encodedId}?tab=vista`;
  }
  return "/GestionCursos";
}

/**
 * @param {string} courseId
 * @param {string} returnTo
 * @returns {string}
 */
export function buildVistaCursoAdminPath(courseId, returnTo) {
  const encodedId = encodeCourseIdForPath(courseId);
  if (encodedId.length === 0) {
    return "/GestionCursos";
  }
  const safeReturnTo = normalizeReturnTo(returnTo) ?? VISTA_CURSO_RETURN_GESTION;
  const params = new URLSearchParams({ returnTo: safeReturnTo });
  return `/admin/vista-cursos/${encodedId}?${params.toString()}`;
}
